import React, { Fragment, PureComponent } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { withTheme } from 'styled-components';
import { withTranslation, Trans } from 'react-i18next';
import { capfl } from 'common/utils';
import loadable from '@loadable/component';

const Row = loadable(() => import('common/components/styleguide/grid/Row'));
const Column = loadable(() => import('common/components/styleguide/grid/Column'));

const Alert = loadable(() => import('common/components/styleguide/Alert'));
const Emoji = loadable(() => import('common/components/styleguide/Emoji'));

import Price from 'common/components/_base/Price';

import { Headline6 } from 'common/components/styleguide/Headline';
import { formatPrice } from 'common/utils';

import { getIsB2BLockedSelector } from 'common/selectors';
import { isUserLoggedSelector } from 'common/selectors/user';

class DetailPrice extends PureComponent {
  render() {
    const {
      data,
      isLocked,
      theme,
      showAlert = true,
      t
    } = this.props;
    const {
      finalPriceData = {},
      // priceData,
      // retailPriceData,
      standardPriceData = {},
      finalPrice,
      finalPriceWithoutDPH,
      specialPrice,
      measureUnit,
      discount,
      name
    } = data;

    if (isLocked) {
      return (
        <Alert type={"danger"}>
          <Emoji label={t("restricted area")}>👮</Emoji> {capfl(t('this content is locked!'))}
        </Alert>
      )
    }

    const showOldPrice = (_.get(finalPriceData, 'price', 0) < _.get(standardPriceData, 'price', 0));
    const priceDifference = showOldPrice ? formatPrice(_.get(standardPriceData, 'price', 0) - _.get(finalPriceData, 'price', 0)) : 0;
    const currencySymbol = _.get(finalPriceData, 'currencySymbol', '');

    return (
      <Fragment>
        {showOldPrice && priceDifference && showAlert ? (
          <Alert>
            <Trans i18nKey="productDiscoutBlock" discount={discount} name={name}>
              <Emoji label={t("discount")}>🎉</Emoji> Discount <strong>{{discount}}</strong> for this product. You will save up to <strong>{{priceDifference}} {{currencySymbol}}</strong> from standard price.
            </Trans>
          </Alert>
        ) : ('')}
        <Row>
          <Column size={{ xs: showOldPrice ? 6 : 12, lg: showOldPrice ? 5 : 12 }}>
            <Headline6>{capfl(t('internet price'))}</Headline6>
            <Price
                finalPrice={!_.isEmpty(finalPriceData) ? finalPriceData.priceFormatted : finalPrice}
                finalPriceWithoutDPH={!_.isEmpty(finalPriceData) ? finalPriceData.priceWithoutVatFormatted : finalPriceWithoutDPH}
                measureUnit={measureUnit}
                showDiscount={false}
                showWithoutVat={true}
                useFormatPrice={!_.isEmpty(finalPriceData) ? false : true}
                useFormatDiscount={false}
                useCurrencySymbol={!_.isEmpty(finalPriceData) ? false : true}
                customStyle={{
                  finalPrice:{
                    fontSize:'1.75em',
                    fontWeight: 'bolder'
                  }
                }}
            />
          </Column>
          {showOldPrice && !_.isEmpty(standardPriceData) ? (
            <Column size={{ xs: 6, lg: 7 }}>
              <Headline6 color={"gray"}>{capfl(t('standard price'))}</Headline6>
              <Price
                  finalPrice={standardPriceData.priceFormatted}
                  finalPriceWithoutDPH={standardPriceData.priceWithoutVatFormatted}
                  discount={discount}
                  measureUnit={measureUnit}
                  showDiscount={false}
                  showWithoutVat={true}
                  useFormatPrice={false}
                  useFormatDiscount={false}
                  useCurrencySymbol={false}
                  customStyle={{
                    finalPrice:{
                      color: _.get(theme, 'colors.lgray'),
                      fontSize:'1.75em',
                      fontWeight: 'normal',
                      textDecoration: 'line-through'
                    }
                  }}
              />
            </Column>
          ) : ('')}
        </Row>
      </Fragment>
    );
  }
}

const makeMapStateToProps = () => {
  const isUserLogged = isUserLoggedSelector();
  const isB2BLockedSelector = getIsB2BLockedSelector();
  return (state, props) => {
    return {
      isLocked: isB2BLockedSelector(state, props) ? (isUserLogged(state, props) ? false : true) : false
    };
  };
};

const DetailPriceConnected = connect(
  makeMapStateToProps,
  undefined
)(DetailPrice);

export default withTranslation()(withTheme(DetailPriceConnected));
